import { AnnouncementService } from './../../Services/announcement.service';
import { CourseService } from './../../Services/course.service';
import { CourseriddenService } from './../../Services/courseridden.service';
import { saveAs } from 'file-saver';
import { CalendarService } from './../../Services/calendar.service';
import { GeneralSettingsService } from '../../Services/general-settings.service';
import { AlertService } from '../../Services/alert.service';
import { MemberService } from '../../Services/member.service';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Response } from '@angular/http';
import { IMyDpOptions, IMyMarkedDate, IMyDayLabels } from 'mydatepicker';
import Swal, { SweetAlertType } from 'sweetalert2';
import { AuthService } from '../../Services/auth.service';
import { UploadService } from '../../Services/upload.service';
import { ArrivalService } from '../../Services/arrival.service';
import { DiscountService } from '../../Services/discount.service';

@Component({
  selector: 'app-admin-settings-form',
  template: require('./admin-settings-form.component.html'),
  styles: [require('./admin-settings-form.component.css')]
})
export class AdminSettingsFormComponent implements OnInit {
  @ViewChild("SignatureUploadInput") SignatureUploadInput: ElementRef;
  @ViewChild("StampUploadInput") StampUploadInput: ElementRef;
  

  announcemetText: string = "";
  newSubscriptionNotifyEmail: string = "";
  newSubscriptionNotifyToName : string = "";
  MembershipFeeText:string ="";

  healthInsurancePaperCheck:boolean= false;
  signatureStatus: boolean = false;
  stampStatus: boolean = false;
    
  SiteUrl:string="";
  EmailAddress:string="";
  PresidentName:string="";
  VzwAddress:string="";
  VzwBankAccount:string="";

  generalSettings: any = {};
  availableYears : any = [];
  selectedYear: number = 0;
  calenderBeginDate: any;
  calenderEndDate:any;


  myDatePickerOptions: IMyDpOptions = {
    todayBtnTxt: 'Vandaag',
    dateFormat: 'dd/mm/yyyy',
    firstDayOfWeek: 'mo',
    sunHighlight: true,
    markCurrentDay: true,
    height: '34px',
    width: '210px',
    alignSelectorRight: false,
    openSelectorTopOfInput: false,
    indicateInvalidDate: true,
    monthSelector: true,
    yearSelector: true,
    minYear: 1920,
    maxYear: 2200,
    componentDisabled: false,
    editableDateField:false,
    showClearDateBtn: true,
    showDecreaseDateBtn: false,
    showIncreaseDateBtn: false,
    showSelectorArrow: true,
    showInputField: true,
    openSelectorOnInputClick: false,
    disableHeaderButtons: true,
    showWeekNumbers: false,
    markDates: [],
    satHighlight: false,
    highlightDates: [],
    markWeekends: <IMyMarkedDate>{},
    monthLabels: {
        1: 'Januari',
        2: 'Februari',
        3: 'Maart',
        4: 'April',
        5: 'Mei',
        6: 'Juni',
        7: 'July',
        8: 'Augustus',
        9: 'September',
        10: 'Oktober',
        11: 'November',
        12: 'December'
    },
    dayLabels: <IMyDayLabels>{
      su: 'zo', mo: 'ma', tu: 'di', we: 'wo', th: 'do', fr: 'vr', sa: 'za'
    },
    allowDeselectDate: true,
    disableWeekdays: [],
    allowSelectionOnlyInCurrentMonth: true
};

  constructor(private memberService: MemberService,
    private alertService: AlertService,
    private generalSettingsService: GeneralSettingsService,
    private calendarService: CalendarService,
    private courseRidden: CourseriddenService,
    private courseService: CourseService,
    private announcementService: AnnouncementService,
    private uploadService:UploadService,
    private arrivalService: ArrivalService,
    private discountService: DiscountService,
    private auth: AuthService) { }

  ngOnInit() {
    this.generalSettingsService.getBeginEndCalendarDates().subscribe(res => {
      if (res) {
        // console.log(res[0]);
        this.generalSettings = res[0];
        var db = new Date(this.generalSettings.calenderBeginDate)
        var de = new Date(this.generalSettings.calenderEndDate)
        
        this.calenderBeginDate = {
                jsdate: db,
                date:{year: db.getFullYear(), month: db.getMonth() +1, day: db.getDate()}
              };     
        
        this.calenderEndDate = {
          jsdate: de,
          date:{year: de.getFullYear(), month: de.getMonth() +1, day: de.getDate()}
        };    

      }
    });
    this.loadAnnouncement()
    this.loadNewSubscriptionNotifyToName()
    this.loadNewSubscriptionNotifyEmail()
    this.loadAllYears()
    this.loadGeneralInformation()
    this.checkSignatureAndStamp()
    this.loadSubscriptionFee()
    this.getHealthInsuranceCheck()
  }

  resetSubscriptions() {
    Swal.fire({
      title: 'Ben je zeker?',
      text: "Ben je zeker dat je alle betalingen, kortingen en kortingscodes wil wissen?",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Jep',
      cancelButtonText: 'Nope'
    }).then((result) => {
      if (result.value) {
          this.memberService.resetSubscriptions().subscribe(res => {
              this.showAlert(res, "Alle betalingen gereset", "Er is iets misgegaan met de reset");
            }, error => {
              if (error.status == 403) {
                this.alertService.error("Je hebt niet de juiste rechten!")
              }
          });
      }
    });
  }

  sendSubscriptionPaymentMails(){
    this.memberService.getAmountMemberSubscriptionEmails().subscribe( res => {
      if (res.status == 200){
        var innerHtml=`Ben je zeker dat je alle ingeschrevenen de afrekening email  wil sturen?<br><br>`

        if (res.value> 1){
          innerHtml += `Er zullen <strong>${res.value}</strong> emails worden vestuurd.`
        }else{
          innerHtml += `Er zal <strong>${res.value}</strong> email worden verstuurd.`
        }


        Swal.fire({
          title: 'Ben je zeker?',
          html: innerHtml,
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Jep',
          cancelButtonText: 'Nope'
        }).then((result) => {
          if (result.value) {
            this.memberService.sendAllMemberSubscriptionPaymentEmails().subscribe (resEmailSend => {
              if (res.status == 200){
                Swal.fire({
                  title: 'E-mails verstuurd',
                  text: "Er zijn "+resEmailSend.value.emailMessagesSend+" mail(s) verstuurd",
                  showCancelButton: false,
                  confirmButtonColor: '#3085d6',
                  confirmButtonText: 'Ok',
                })
              }
            })           
          }
        });
      }
    })
  }

  saveCalenderDates() {
    this.generalSettingsService.setBeginEndCalendarDates({
      'calenderBeginDate': String(this.calenderBeginDate.date.year)+"-"+String(this.calenderBeginDate.date.month)+"-"+String(this.calenderBeginDate.date.day),
      'calenderEndDate': String(this.calenderEndDate.date.year)+"-"+String(this.calenderEndDate.date.month)+"-"+String(this.calenderEndDate.date.day)
    }).subscribe(res => {
      this.showAlert(res, "Begin- en eind datum bewaard", "Er is iets misgelopen met het bewaren");
    }, error => {
      if (error.status == 403) {
        this.alertService.error("Je hebt niet de juiste rechten!")
      }
      else {
        console.log(error);
      }
    });
  }

  private showAlert(code: number, message_succes: string, message_error: string) {
    if (code == 200) {
      this.alertService.success(message_succes);
    }
    else {
      this.alertService.error(message_error);
    }
  }

  downloadExcel() {
    this.calendarService.downloadExcel().subscribe((res: Response) => {
      if (res.headers) {
        if (res.headers) {
          var header = "";
          header = res.headers.get('content-disposition') || "";
          var startIndex = header.indexOf("filename=") + 9; // Adjust '+ 9' if filename is not the right one.
          var endIndex = header.indexOf(";", startIndex);
          var filename = header.substring(startIndex, endIndex);
          // console.log("filename: " + filename)
          saveAs(res.blob(), filename);
        }
      }
    });
  }

  downloadStopplaatsenExcel(){
    this.arrivalService.downloadExcel().subscribe((res: Response) => {
      if (res.headers) {
        if (res.headers) {
          var header = "";
          header = res.headers.get('content-disposition') || "";
          var startIndex = header.indexOf("filename=") + 9; // Adjust '+ 9' if filename is not the right one.
          var endIndex = header.indexOf(";", startIndex);
          var filename = header.substring(startIndex, endIndex);
          // console.log("filename: " + filename)
          saveAs(res.blob(), filename);
        }
      }
    });
  }

  downloadMembersInExcell() {
    this.memberService.downloadExcel().subscribe((res: Response) => {
      if (res.headers) {
        if (res.headers) {
          var header = "";
          header = res.headers.get('content-disposition') || "";
          var startIndex = header.indexOf("filename=") + 9; // Adjust '+ 9' if filename is not the right one.
          var endIndex = header.indexOf(";", startIndex);
          var filename = header.substring(startIndex, endIndex);
          // console.log("filename: " + filename)
          saveAs(res.blob(), filename);
        }
      }
    });
  }

  downloadMembersForGmailContacts(){
    this.memberService.downloadMembersForGmailContacts().subscribe((res: Response)=> {
      if (res.headers) {
        if (res.headers) {
          var header = "";
          header = res.headers.get('content-disposition') || "";
          var startIndex = header.indexOf("filename=") + 9; // Adjust '+ 9' if filename is not the right one.
          var endIndex = header.indexOf(";", startIndex);
          var filename = header.substring(startIndex, endIndex);
          // console.log("filename: " + filename)
          saveAs(res.blob(), filename);
        }
      }
    })
  }

  downloadCoursesRiddenInExcell(year: number) {
    // console.log(year);
    this.courseRidden.downloadAllUsersExcel(year).subscribe((res: Response) => {
      if (res.headers) {
        if (res.headers) {
          var header = "";
          header = res.headers.get('content-disposition') || "";
          var startIndex = header.indexOf("filename=") + 9; // Adjust '+ 9' if filename is not the right one.
          var endIndex = header.indexOf(";", startIndex);
          var filename = header.substring(startIndex, endIndex);
          // console.log("filename: " + filename)
          saveAs(res.blob(), filename);
        }
      }
    });
  } 

  downloadCoursesRiddenOverview(year: number){
    this.courseRidden.downloadCoursesRiddenOverview(year).subscribe( (res: Response) =>{
      if (res.headers) {
        if (res.headers) {
          var header = "";
          header = res.headers.get('content-disposition') || "";
          var startIndex = header.indexOf("filename=") + 9; // Adjust '+ 9' if filename is not the right one.
          var endIndex = header.indexOf(";", startIndex);
          var filename = header.substring(startIndex, endIndex);
          // console.log("filename: " + filename)
          saveAs(res.blob(), filename);
        }
      }
    });
  }

  getYearOverviewPerGroupXlsx(year: number){
    this.courseRidden.downloadYearOverviewPerGroup(year).subscribe ( (res: Response) => {
      if (res.headers) {
        if (res.headers) {
          var header = "";
          header = res.headers.get('content-disposition') || "";
          var startIndex = header.indexOf("filename=") + 9; // Adjust '+ 9' if filename is not the right one.
          var endIndex = header.indexOf(";", startIndex);
          var filename = header.substring(startIndex, endIndex);
          // console.log("filename: " + filename)
          saveAs(res.blob(), filename);
        }
      }
    });
  }

  getYearOverviewDiscountsUsedXlsx(year: number){
    this.discountService.downloadYearOverviewDiscountUsed(year).subscribe ( (res: Response) => {
      if (res.headers) {
        if (res.headers) {
          var header = "";
          header = res.headers.get('content-disposition') || "";
          var startIndex = header.indexOf("filename=") + 9; // Adjust '+ 9' if filename is not the right one.
          var endIndex = header.indexOf(";", startIndex);
          var filename = header.substring(startIndex, endIndex);
          // console.log("filename: " + filename)
          saveAs(res.blob(), filename);
        }
      }
    });
  }

  saveAnnouncement(){
    // console.log("Save Announcement");
    // console.log(this.announcemetText);
    this.announcementService.setAnnouncement(this.announcemetText).subscribe( (x:any)=> {
      // console.log("Save announcement");
      // console.log(x);
      this.showAlert(x.status,"Bewaren successvol!",x.value);
    })
  }

  loadAnnouncement(){
    this.announcementService.getAnnouncement().subscribe(x => {
      this.announcemetText = x.value
    })
  }

  loadSubscriptionFee(){
    this.generalSettingsService.getSubscriptionFee().subscribe( (res:any)=>{
      if (res.status == 200){
        this.MembershipFeeText = res.value.subscriptionFee;
      }
    })
  }

  saveMembershipFee(){
    this.generalSettingsService.setSubscriptionFee(this.MembershipFeeText).subscribe( (res:any)=>{
      if (res.status == 200){
        Swal.fire({
          title: 'Lidgeld is bewaard',
          // text: "Lidgeld is bewaard",
          showCancelButton: false,
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'Ok',
        })
      }
    } )
  }

  saveNewSubscriptionNotifyEmail(){
    this.generalSettingsService.setNewSubscriptionNotifyEmail(this.newSubscriptionNotifyEmail, this.newSubscriptionNotifyToName).subscribe( x=>{
      // console.log("save new subscriber notifier");
      // console.log(x);
      this.showAlert(x, "Alle betalingen gereset", "Er is iets misgegaan met de reset");
    } )
  }

  loadNewSubscriptionNotifyEmail(){
    this.generalSettingsService.getNewSubscriptionNotifyEmail().subscribe(x => {
      this.newSubscriptionNotifyEmail = x.value
    })
  }

  loadNewSubscriptionNotifyToName(){
    this.generalSettingsService.getNewSubscriptionNotifyToName().subscribe(x => {
      this.newSubscriptionNotifyToName = x.value
    })
  }

  saveGeneralInformation(){
    var data =[
      {"key":"president", "value":this.PresidentName},
      {"key":"url", "value":this.SiteUrl},
      {"key":"email", "value":this.EmailAddress},
      {"key":"address", "value":this.VzwAddress},
      {"key":"bankrekening", "value":this.VzwBankAccount}
    ]
    this.generalSettingsService.setGeneralInformation(data).subscribe( (x:any)=>{
      // console.log(x);
      
      this.showAlert(x.status,"Bewaren successvol!",x.value);
    })
  } 

  clearAnnouncementText(){
    this.announcemetText = "";
  }

  clearNewSubscriptionNotifyEmail(){
    this.newSubscriptionNotifyEmail = "";
  }

  clearNewSubscriptionNotifyToName(){
    this.newSubscriptionNotifyToName = "";
  }

  clearSiteUrl(){
    this.SiteUrl = "";
  }
  clearEmailAddress(){
    this.EmailAddress = "";
  }
  clearPresidentName(){
    this.PresidentName = "";
  }
  clearVzwAddress(){
    this.VzwAddress = "";
  }
  clearVzwBankAccount(){
    this.VzwBankAccount = "";
  }

  clearAMembershipFeeText(){
    this.MembershipFeeText = "0";
  }
  
  loadAllYears(){
    this.courseRidden.getAllYears().subscribe( x =>{
      this.availableYears = x.sort((n1: number,n2:number) => {
        if (n1 < n2) {
            return 1;
        }
    
        if (n1 > n2) {
            return -1;
        }
    
        return 0;
    });
      // console.log(this.availableYears);
      this.selectedYear = this.availableYears[0];
    })
  }

  loadGeneralInformation(){
    this.generalSettingsService.getGeneralInformation().subscribe ( (x:any)=>{
      this.SiteUrl = x.siteUrl;
      this.EmailAddress = x.email;
      this.PresidentName = x.president;
      this.VzwBankAccount = x.bankAccount;
      this.VzwAddress = x.address;    
    });
  }

  uploadSignature(){
    var nativeElement: HTMLInputElement = this.SignatureUploadInput.nativeElement;
    if (nativeElement != null) {
      var files = nativeElement.files;
      if (files != null) {
        var file = files[0];
        this.uploadService.uploadSignature(file).subscribe((x:any) => {
          // console.log(x);
          if (x.status == 200){
            this.checkSignatureAndStamp();
          }
        })
      }
    }
  }

  uploadStamp(){
    var nativeElement: HTMLInputElement = this.StampUploadInput.nativeElement;
    if (nativeElement != null) {
      var files = nativeElement.files;
      if (files != null) {
        var file = files[0];
        this.uploadService.uploadStamp(file).subscribe((x:any) => {
          // console.log(x);
          if (x.status == 200){
            this.checkSignatureAndStamp();
          }
        })
      }
    }
  }
  
  checkSignatureAndStamp(){
    this.uploadService.checkAsset('signature').subscribe ( (res:any)=>{
      if (res.status == 200){
        this.signatureStatus = true;
      }else {
        this.signatureStatus = false;
      }
    })

    this.uploadService.checkAsset('stamp').subscribe ( (res:any)=>{
      if (res.status == 200){
        this.stampStatus = true;
      }else {
        this.stampStatus = false;
      }
    })

  }

  healthInsurancePaperCheckChanged(event:Event){
    // console.log("healthInsurancePaperCheckChanged", event);
    this.healthInsurancePaperCheck = (event.target as HTMLInputElement).checked;
    // console.log("this.healthInsurancePaperCheck: ", this.healthInsurancePaperCheck);
    this.generalSettingsService.setHealthInsurancePaperCheck( this.healthInsurancePaperCheck).subscribe( (res:any)=>{
      // console.log("setHealthInsuranceCheck res: ",res);
    })
  }

  getHealthInsuranceCheck(){
    this.generalSettingsService.getHealthInsurancePaperCheck().subscribe( (res:any)=>{
      if (res.status == 200){
        this.healthInsurancePaperCheck = JSON.parse(res.value.healthInsurancePapersAvailable.toLowerCase()); ;
      }
    })
  }

  sendHealthInsurancePaperToAll(){
    this.memberService.getNumberOfEmailAddresses(true).subscribe ( (res:any)=>{
      if (res.status == 200){
        var totalMembersWithEmail = res.value.totalMembersWithEmail;

        Swal.fire({
          title: 'Ben je zeker?',
          html: "Alle ["+totalMembersWithEmail+"] emails met het mutualiteit document zullen worden vestuurd",
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Jep',
          cancelButtonText: 'Nope'
        }).then((result) => {
          if (result.value) {
            this.memberService.sendAllHealthInsurancePapers().subscribe( (res:any)=>{
              if (res.status == 200){
                Swal.fire({
                  title: 'E-mail verstuurd',
                  text: "Er zijn "+res.value.emailMessagesSend+ "/" +  res.value.totalMembersWithEmail +" emails verstuurd.",
                  showCancelButton: false,
                  confirmButtonColor: '#3085d6',
                  confirmButtonText: 'Ok',
                })
              }
            })
           
          }
        });       
      }
    })
  }

 


}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/admin-settings-form/admin-settings-form.component.ts